
<template>
  <div class="clearfix">
    <el-pagination
      ref="Pagination"
      :current-page.sync="currentPage2"
      background
      layout="prev, pager,
      next"
      @current-change="CurrentChange"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: [
    "Total",
    "Page",
    "BiaoSi",
  ],
  data() {
    return {
      total: null,
      Listindex: "",
      currentPage2: null,
      biaoshi: "",
    };
  },
  components: {},
  watch: {
    deep: true,
    Total(val) {
      this.total = val;
      if (this.Listindex == 4) {
        this.currentPage2 = 1;
        this.$parent.addressDetail();
      } else if (this.Listindex != 4) {
        this.currentPage2 = sessionStorage.getItem("tiaozhuan");
      }
    },
    Page(val) {
      // console.log(val);
      this.currentPage2 = val;
      // console.log("aaa");
    },
    BiaoSi(val) {
      this.biaoshi = val;
    },
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/BlockList") {
          this.Listindex = 1;
        } else if (
          to.path === "/pc/TransactionsList" ||
          to.path === "/pc/BkDetail"
        ) {
          this.Listindex = 2;
        } else if (to.path === "/pc/To") {
          this.Listindex = 3;
        } else if (to.path === "/pc/BkHash") {
          this.Listindex = 4;
        } else if (to.path === "/pc/TopValidators") {
          this.Listindex = 5;
        } else if (to.path === "/pc/ValidatorDetail") {
          this.Listindex = 6;
        } else if (to.path === "/pc/BkHeight") {
          this.Listindex = 7;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.currentPage2 = this.getContextData("tiaozhuan") || 1;
  },

  mounted() {},
  methods: {
    CurrentChange(val) {
      let data = val;
      this.$emit("PaginationChanage", data);
      this.fasqq();
    },
    fasqq() {
      if (this.Listindex == 1) {
        this.$parent.blockList();
        this.setContextData("tiaozhuan", this.currentPage2);
      } else if (this.Listindex == 2) {
        this.$parent.TransactionsList();
        this.setContextData("tiaozhuan", this.currentPage2);
      } else if (this.Listindex == 3) {
        this.$parent.verifyList();
        this.setContextData("tiaozhuan", this.currentPage2);
      } else if (this.Listindex == 4) {
        this.$parent.addressDetail();
      } else if (this.Listindex == 5) {
        this.$parent.ValidakList();
        this.setContextData("tiaozhuan", this.currentPage2);
      } else if (this.biaoshi == 1) {
        this.$parent.VerifyLists();
      }else if(this.Listindex == 6){
        this.$parent.Delegations();
        this.setContextData("tiaozhuan", this.currentPage2);
      }else if(this.Listindex == 7){
        this.$parent.heightDetail();
        this.setContextData("tiaozhuan", this.currentPage2);
      }
    },
    setContextData: function (key, value) {
      // console.log("sdsadsa");
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    }, 
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "aaa";
  src: url("../../../assets/font/NotoSans-Regular.ttf");
}
.el-pagination {
  float: right;
  ::v-deep button {
    min-width: 24px !important;
    
    height: 24px !important;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.55) !important;
    background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
    // padding: ;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
   
      height: 24px !important;
      background: #3c485c !important;
      border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #00a870 !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
